import { route, resolve } from './lib/router';
import { renderHome } from './pages/home';
import { renderCompound } from './pages/compound';
import { renderGoal } from './pages/goal';
import { renderStacks } from './pages/stacks';
import { renderTrack } from './pages/track';
import { renderProfile } from './pages/profile';
import { renderQuickLog } from './pages/quick_log';
import { renderToday } from './pages/today';
import { renderCreators } from './pages/creators';
import { maybeShowDisclaimer } from './lib/disclaimer';

const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());

route('/',          renderHome);
route('/today',     renderToday);
route('/stacks',    renderStacks);
route('/compounds', renderHome);
route('/c/:id',     renderCompound);
route('/g/:id',     renderGoal);
route('/track',     renderTrack);
route('/creators',  renderCreators);
route('/profile',   renderProfile);
route('/quick-log', renderQuickLog);

// SPA link interception — let our router handle internal links instead of full reload.
document.addEventListener('click', (e) => {
  const t = e.target as HTMLElement;
  const a = t.closest('a');
  if (!a) return;
  const href = a.getAttribute('href');
  if (!href || !href.startsWith('/') || a.getAttribute('target') === '_blank' || a.hasAttribute('download')) return;
  if (a.getAttribute('rel')?.includes('external')) return;
  e.preventDefault();
  history.pushState({}, '', href);
  resolve();
});
window.addEventListener('popstate', resolve);

maybeShowDisclaimer();
resolve();
